import MobileSliderPagesWrapper from "../components/MobileSliderPagesWrapper.jsx";
import MobileSliderPagesHeader from "../components/MobileSliderPagesHeader.jsx";
import Withdraw from "../../../../modules/Account/components/Withdraw/Withdraw";
import { useCallback, useEffect } from "react";
import { MOBILE_SLIDER_PAGES_IDS } from "../mobileSliderPagesConstants";
import { openMobileSliderPageAction } from "../../../mobileAppActions";
import { connect } from "react-redux";
import { useCashierWithdrawalAmount } from "../../../../modules/Cashier/cashierHooks";
import { accountGetPortfolioAction } from "../../../../modules/Account/accountActions";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";

function SlideMobileWithdraw(props) {
    const {getPortfolio, openMobileSliderPage} = props;
    const withdrawalAmount = useCashierWithdrawalAmount();
    const {getLangPath} = useLangContext();

    useEffect(() => {
        getPortfolio();
    }, [getPortfolio]);

    const handleVerifyButtonClick = useCallback(() => {
        openMobileSliderPage(MOBILE_SLIDER_PAGES_IDS.VERIFY);
    }, [openMobileSliderPage]);

    const handleDepositNowButtonClick = useCallback(() => {
        openMobileSliderPage(MOBILE_SLIDER_PAGES_IDS.DEPOSIT);
    }, [openMobileSliderPage]);

    const payoutCreateCallback = useCallback(() => {
        openMobileSliderPage(MOBILE_SLIDER_PAGES_IDS.WITHDRAWAL_REQUEST_SENT);
    }, [openMobileSliderPage]);

    return <MobileSliderPagesWrapper>
        <MobileSliderPagesHeader>
            <h4 className="mb-0 text-center f16">{getLangPath('menu.withdraw')}</h4>
        </MobileSliderPagesHeader>
        <Withdraw
            isSelectMethodSlider
            onDepositNowButtonClick={handleDepositNowButtonClick}
            onVerifyButtonClick={handleVerifyButtonClick}
            payoutCreateCallback={payoutCreateCallback}
            withdrawalAmount={withdrawalAmount}
        />
    </MobileSliderPagesWrapper>
}

const mapDispatchToProps = (dispatch) => ({
    getPortfolio: () => dispatch(accountGetPortfolioAction()),
    openMobileSliderPage: payload => dispatch(openMobileSliderPageAction(payload)),
});

export default connect(null, mapDispatchToProps)(SlideMobileWithdraw);
